// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".baseline[data-v-38b39ae4]{vertical-align:baseline}", ""]);
// Exports
module.exports = exports;
